import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import './ConfirmDialog.css';
import {useTranslation} from "react-i18next";

function ConfirmDialog({ message = '', onConfirm = () => {}, onCancel = () => {} }) {
    const { t } = useTranslation();

    return (
        <>
            {/* Backdrop */}
            <div className='confirm-dialog-backdrop' onClick={onCancel} />

            {/* Dialog */}
            <div className='confirm-dialog' role='alertdialog' aria-modal='true'>
                <div className='confirm-dialog-content'>
                    <div className='confirm-dialog-icon'>
                        <FaExclamationTriangle />
                    </div>

                    <h2 className='confirm-dialog-title'>{t('confirmDialog.confirmDialogTitle')}</h2>

                    <p className='confirm-dialog-message'>{message}</p>

                    <div className='confirm-dialog-actions'>
                        <button
                            className='confirm-dialog-button cancel'
                            onClick={onCancel}
                        >
                            {t('confirmDialog.confirmCancel')}
                        </button>
                        <button
                            className='confirm-dialog-button confirm'
                            onClick={onConfirm}
                            autoFocus
                        >
                            {t('confirmDialog.confirmButton')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ConfirmDialog;
